module.exports = __webpack_public_path__ + "img/status-3.f2661107.png";